import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/auth";
import ReportsModule from "./modules/reports";
import dashboardLinks from "./dashboardLinks";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    AuthModule,
    ReportsModule
  },

  state: {
    dashboardLinks,
    lang: localStorage.getItem("lang") || {
      text: "EN",
      value: "en",
      dir: "ltr"
    },
    globalSnackbar: {
      color: "success",
      show: false,
      text: ""
    }
  },

  getters: {
    globalSnackbar: state => state.globalSnackbar,

    getSidebarLinks(state) {
      let finalLinks = [];
      let allLinks = state.dashboardLinks;
      let cans = store.getters["AuthModule/permissions"];
      allLinks.forEach(link => {
        if (link.children) {
          let parent = null;
          let accessibleChildren = [];
          link.children.forEach(child => {
            if (cans.indexOf(child.can) > -1) {
              parent = link;
              accessibleChildren.push(child);
            }
          });
          if (parent) {
            parent.children = accessibleChildren;
            finalLinks.push(parent);
          }
        } else if (cans.indexOf(link.can) > -1) finalLinks.push(link);
      });

      return finalLinks;
    }
  },

  mutations: {
    showSnackbar(state, payload) {
      state.globalSnackbar.color = payload.stateType;
      state.globalSnackbar.text = payload.text;
      state.globalSnackbar.show = payload.show;
    },
    setLang(state, lang) {
      state.lang = lang;
    }
  },

  actions: {}
});
